<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <loader v-show="loading"/>
        <CCardHeader>
          <c-header :data="data" @update="headerUpdate" />
        </CCardHeader>
        <CCardBody v-if="data.id">
          <ol class="question-container">
            <li v-for="(v, k) in data.detail" :key="k">
              <div class="question">
                <span
                  v-html="
                    v.question + ' <small>' + v.question_group_id + '</small>'
                  "
                ></span>
                <div class="form-inline q-action-button">
                  <label>No Urut Soal:</label>
                  <div class="col-md-3">
                    <number-selector :min="1" :max="data.q_total" v-model="v.number" :data="v" @input="changeNumber"/>
                  </div>
                </div>
                <div class="answer">
                  <ol type="A">
                    <li v-for="(va, ka) in v.answers" :key="ka" v-bind:class="{'answer-correct': v.answer && v.answer.id == va.id}">
                      <span v-html="va.answer"/>
                    </li>
                  </ol>
                </div>
              </div>
            </li>
          </ol>
          <div class="row">
            <div class="col-12">
              <label> Tambahkan Paket Soal Ke Seri Tryout</label>
            </div>
            <br />
            <div class="col-md-8">
              <question-group-selector
                style="font-size: 16px"
                v-model="question_group"
              />
            </div>
            <button
              class="btn btn-success"
              style="font-size: 14px"
              @click="tambahPaket"
            >
              <CIcon name="cil-plus" /> Tambahkan
            </button>
          </div>
          <div class="question-group-code-item">
            <span class="" v-for="(v, k) in data.groups" :key="k"
              >{{ v.code }}
              <a class="pointer" @click="deleteGroup(v.id)"
                ><CIcon name="cil-x-circle" /></a
            ></span>
          </div>
        </CCardBody>
        <CCardFooter v-if="data.id">
          <div class="form-group">
            <button class="btn btn-success" @click="save">Simpan</button>
          </div>
          <div class="form-group" v-show="data.id">
            <button class="btn btn-success" @click="showInstruction = true">Tambah Instruksi</button>
          </div>
        </CCardFooter>
      </CCard>
    </CCol>
    <c-s-input-petunjuk
      :showModal="showInstruction"
      :data="instruction"
      @cancel="showInstruction = false"
      @save="saveInstruction"
    />
  </CRow>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import CSInputPetunjuk from "./CSInputPetunjuk.vue";
import { showErrorMessage } from "../../lib/helpers";
import CHeader from "./CHeader.vue";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import QuestionGroupSelector from "../../components/QuestionGroupSelector";
import NumberSelector from "../../components/NumberSelector";
import Loader from '../../components/Loader.vue';
export default {
  components: {
    CHeader,
    QuestionGroupSelector,
    CSInputPetunjuk,
    NumberSelector,
    Loader,
  },
  data() {
    return {
      data: {},
      question_group: null,
      showInstruction: false,
      instruction: {},
      paginate: {},
      loading: true
    };
  },
  created() {
    const params = this.$route.params;
    if (params && params.id) {
      this.get(params.id);
      this.getInstruction(params.id);
    }
  },
  methods: {
    get(id) {
      this.loading = true;
      HTTPAUTH.get("/api/v1/admin/series/" + id).then((res) => {
        this.data = res.data.data;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    removeQuestion(id) {
      HTTPAUTH.delete(`/api/v1/admin/series/${this.data.id}/detail/${id}`)
        .then(() => {
          this.get(this.data.id);
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    tambahPaket() {
      if (!this.question_group) {
        this.$toasted
          .error("Silahkan pilih paket soal yang akan ditambahkan")
          .goAway();
        return;
      }
      HTTPAUTH.post(`/api/v1/admin/series/${this.data.id}/group`, {
        groups: [this.question_group],
      })
        .then(() => {
          this.$toasted.success("Berhasil mengupdate data").goAway();
          this.get(this.data.id);
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    save() {
      HTTPAUTH.post(
        "/api/v1/admin/series/" + this.data.id + "/detail",
        this.data
      )
        .then(() => {
          this.$toasted.success("Data berhasil disimpan").goAway();
          this.get(this.data.id);
          this.getInstruction(this.data.id)
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    headerUpdate(id) {
      this.get(id);
    },
    deleteGroup(id) {
      HTTPAUTH.delete(`/api/v1/admin/series/${this.data.id}/detail/${id}`)
        .then(() => {
          this.get(this.data.id);
          this.$toasted.success("Data berhasil dihapus").goAway();
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    getInstruction(seriesID) {
      HTTPAUTH.get(`/api/v1/admin/series-instruction/${seriesID}/series`).then(res => {
        this.instruction = res.data.data
      });
    },
    saveInstruction(data) {
      data.series_id = this.data.id;
      HTTPAUTH.post(`/api/v1/admin/series-instruction`, data).then(res => {
        this.instruction = res.data.data
      }).catch((eres) => {
        showErrorMessage(eres)
      });
    },
    changeNumber(d, v) {
      let code = "";
      const params = this.$route.params;
      if (params && params.id) {
        code = params.id
      }
      HTTPAUTH.put(`/api/v1/admin/series/${v.series_detail_id}/number/${d.id}`).then(() => {
        this.get(code);
      }).catch(eres => {
        showErrorMessage(eres)
      })
    }
  },
};
</script>